import { memo, FC } from 'react';

import { MainButton } from '@bizzabo/design-system';
import { makeStyles } from '@material-ui/styles';

import useProfileAnalytics from '../../hooks/useProfileAnalytics';
import { useUserProfileViewContext, ViewType } from '../../context/UserProfileViewProvider';

type FormControlsProps = {
    disableSave: boolean;
};

const FormControls: FC<FormControlsProps> = ({ disableSave }) => {
    const { modalView, setViewType } = useUserProfileViewContext();
    const classes = useStyles();
    const controlClass = modalView ? classes.modalControls : classes.controls;
    const { sendLeaveEditMode } = useProfileAnalytics();

    const handleCancelEdit = () => {
        setViewType(ViewType.READ);
        sendLeaveEditMode();
    };

    return (
        <div className={controlClass}>
            <MainButton type="button" onClick={handleCancelEdit} className={classes.cancelButton}>
                Cancel
            </MainButton>
            <MainButton
                type="submit"
                variant="fill"
                className={classes.saveButton}
                disabled={disableSave}
            >
                Save
            </MainButton>
        </div>
    );
};

const useStyles = makeStyles(
    theme => ({
        controls: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            width: '100vw',
            position: 'sticky',
            bottom: 0,
            padding: '18px 36px',
            boxShadow: '0px -4px 4px rgba(0, 0, 0, 0.06)',
            backgroundColor: theme.palette.greys[100],
            transform: 'translateX(-36px)',
        },
        modalControls: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            marginTop: 'auto',
        },
        cancelButton: {
            border: 0,
            padding: '10px 20px',
        },
        saveButton: {
            marginLeft: 16,
            padding: '10px 20px',
        },
    }),
    { classNamePrefix: 'people-user-profile-form-controls' }
);

export default memo(FormControls);
